<template>
	<ui-card :icon="icon" :title="title" p-off>
		<template #body>
			<tag-manager-filters
				v-model="manager.filters"
				:search-event="searchEventName"
				:filter-options="filterOptions"
				:order-options="orderOptions"
				@applyFilter="applyFilterHandler"
				class="border--botom"
			/>

			<tag-manager-table
				:name="getTableName"
				:table-data="traceableTableData"
				:table-loading="tableLoading"
				:table-columns="tableColumns"
				:delete-all-selected-action="deleteAllSelectedTags"
				:select-all-action="selectAllTags"
				:has-select-itens="hasSelectItens"
				:paginate-loader="paginateLoader"
				@next="nextPageHandler"
			/>
		</template>
		<template #fl></template>
		<template #fr>
			<ui-util-input-button design="no-bt">
				<template #input>
					<ui-input
						v-model="form.tags"
						:groupicon="icon"
						:placeholder="placeholder"
						design="br-off"
						container-design="mb-0"
						type="text"
						size="lg"
						invertgroup
					/>
				</template>
				<template #buttons>
					<ui-select-2
						v-model="form.type"
						:data="tagOptions"
						:search="false"
						design="br-0 mgb-0"
						align="right"
						item-label="label"
						return-value="value"
						placeholder="Tipo de tag"
						size="lg"
					/>
					<ui-button design="lg success brl-off" :disabled="canAddTags" @click="addTags"
						>Adicionar</ui-button
					>
				</template>
			</ui-util-input-button>

			<span v-if="!!obsText" class="obs-text">{{ obsText }}</span>
		</template>
	</ui-card>
</template>

<script>
	import { uiCard } from '@/components/ui/cards'
	import { uiInput } from '@/components/ui/form'
	import { uiButton } from '@/components/ui/buttons'
	import { uiUtilInputButton } from '@/components/ui/form/util'
	import { uiSelect2 } from '@/components/ui/form'

	import tagManagerFilters from './components/tag-manager-filters'
	import tagManagerTable from './components/tag-manager-table'

	const defaultForm = () => ({
		tags: '',
		type: 'system'
	})

	const defaultTagOptions = () => ([
		{ label: 'Sistêmica', value: 'system' },
		{ label: 'Usuário', value: 'user' }
	])

	export default {
		name: 'uiTagManagerConfiguration',

		components: {
			tagManagerTable,
			tagManagerFilters,
			uiCard,
			uiButton,
			uiUtilInputButton,
			uiInput,
			uiSelect2
		},

		props: {
			name: {
				type: String,
				required: true,
			},
			title: {
				type: String,
				required: true,
			},
			icon: {
				type: String,
				required: false,
			},
			obsText: {
				type: String,
				default: '',
			},
			placeholder: {
				type: String,
				default: '',
			},
			tableData: {
				type: Array,
				default: () => [],
			},
			tableColumns: {
				type: Array,
				default: () => [],
			},
			tableLoading: {
				type: Boolean,
				default: false,
			},
			orderOptions: {
				type: Array,
				default: () => [],
			},
			filterOptions: {
				type: Array,
				default: () => [],
			},
			lastPage: {
				type: [String, Number],
				default: 1,
			},
			currentPage: {
				type: [String, Number],
				default: 1,
			},
			hasSelectItens: {
				type: Boolean,
				default: false
			},
			paginateLoader: {
				type: Boolean,
				default: false,
			}
		},

		data() {
			return {
				form: { ...defaultForm() },
				manager: {
					filters: {},
				},
				oldForm: {},
				tagOptions: [...defaultTagOptions()]
			}
		},

		mounted() {
			this.$emit('input', this.manager)
		},

		computed: {
			getTableName() {
				return 'tag-manager-list-' + this.name
			},

			searchEventName() {
				return this.getTableName + ':search-tags'
			},

			traceableTableData() {
				const table = this.getTableName
				return [...this.tableData].map((item) => {
					item.table = table
					return item
				})
			},

			canAddTags() {
				this.$gtm.trackEvent({
                    event: "fac_button_click",
                    category: 'vuejs-origens',
                    action: "click",
                    label: 'Adicionar Origem',
                })
				return !this.form.tags
			},
		},

		methods: {
			deleteAllSelectedTags() {
				const event = this.getTableName + ':delete-all-selected-tags'
				this.$root.$emit(event)
			},

			selectAllTags(bool) {
				const event = this.getTableName + ':select-all-tags'
				this.$root.$emit(event, bool)
			},

			addTags() {
				const event = this.getTableName + ':add-tags'
				this.$root.$emit(event, this.form)
				this.form = { ...defaultForm() }
			},

			previousPageHandler() {
				this.$emit('previous')
			},

			nextPageHandler() {
				this.$emit('next')
			},

			applyFilterHandler() {
				const event = this.getTableName + ':apply-filter'
				this.$root.$emit(event)
			}
		},

		watch: {
			value(value) {
				if (value) this.manager = value
			},

			manager(value) {
				this.$emit('input', value)
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
